import { Stack } from '@mui/material';
import {
  FLOW_MAX_RPA_JOB_CONTEXT_LIMIT,
  FlowDurationUnits,
  FlowGetJobContextMode,
  FlowRpaJobSuccessFilter,
} from 'flow-schema';

import { api } from 'common';

import { BlockValueTemplateField } from '../../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../../ConfigFields/Duration';
import { BlockRadioGroupField } from '../../../ConfigFields/RadioGroupField';
import { BlockSelectField } from '../../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../../ConfigFields/useSelectedNodeField';

export function JobContextFormFields() {
  const { value: mode = FlowGetJobContextMode.FindAll } =
    useSelectedNodeField<FlowGetJobContextMode>('config.mode');

  return (
    <Stack gap={3}>
      <BlockRadioGroupField
        fieldName="config.mode"
        label="Mode"
        row
        defaultValue={FlowGetJobContextMode.FindAll}
        options={[
          {
            label: 'Find all using filters',
            value: FlowGetJobContextMode.FindAll,
          },
          {
            label: 'Get one by RPA Job ID',
            value: FlowGetJobContextMode.GetOneById,
          },
        ]}
      />

      {mode === FlowGetJobContextMode.GetOneById && (
        <BlockValueTemplateField
          fieldName="config.rpaJobId"
          label="RPA Job ID"
          helperText="Enter the reference to the RPA Job ID. e.g. `{{start.data.entity.rpaJobId}}`"
          placeholder="e.g. {{start.data.entity.rpaJobId}}"
        />
      )}

      {mode === FlowGetJobContextMode.FindAll && (
        <>
          <BlockSelectField
            label="Filter by Success Status"
            fieldName="config.successFilter"
            options={[
              { label: 'All', value: FlowRpaJobSuccessFilter.All },
              { label: 'Failed Only', value: FlowRpaJobSuccessFilter.FailedOnly },
              { label: 'Successful Only', value: FlowRpaJobSuccessFilter.SuccessOnly },
            ]}
          />

          <BlockSelectField
            label="Job Kind"
            fieldName="config.jobKind"
            required
            options={Object.entries(api.RpaJob.Kind)
              .map(([key, value]) => ({
                label: key,
                value,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))}
          />

          <BlockDurationField
            variant="BlockValueTemplate"
            fieldName="config.lookbackDuration"
            unitFieldNameSuffix="units"
            allowedUnits={Object.values(FlowDurationUnits)}
            valueLabel="Lookback duration"
          />

          <BlockValueTemplateField
            fieldName="config.limit"
            label="Limit"
            helperText={`Limit the number of jobs to return. Max: ${FLOW_MAX_RPA_JOB_CONTEXT_LIMIT}`}
            placeholder={String(FLOW_MAX_RPA_JOB_CONTEXT_LIMIT)}
          />
        </>
      )}
    </Stack>
  );
}
